import { Page } from '@testsigmainc/models';
import { AxiosRequestHeaders, AxiosResponseHeaders } from 'axios';

import api from '../../../../../api/instance';
import { MobileInspection } from '../models/mobile-inspection.model';

const nameSpace = '/mobile_inspections';

const getMonitoringData = (
  headers: AxiosResponseHeaders,
): AxiosRequestHeaders => {
  return {
    'X-MobileRecording-Action-Finished-At': Date.now(),

    'X-MobileRecording-Session-Id': headers['x-mobilerecording-session-id'],

    'X-MobileRecording-Action': headers['x-mobilerecording-action'],
    'X-MobileRecording-Action-Initiated-At':
      headers['x-mobilerecording-action-initiated-at'],

    'X-MobileRecording-Action-Driver-Call-Initiated-At':
      headers['x-mobilerecording-action-driver-call-initiated-at'],
    'X-MobileRecording-Action-Driver-Call-Finished-At':
      headers['x-mobilerecording-action-driver-call-finished-at'],

    'X-MobileRecording-Action-Hub-Received-At':
      headers['x-mobilerecording-action-hub-received-at'],
    'X-MobileRecording-Action-Hub-Finished-At':
      headers['x-mobilerecording-action-hub-finished-at'],

    'X-MobileRecording-Image-Compression-Initiated-At':
      headers['x-mobilerecording-image-compression-initiated-at'],
    'X-MobileRecording-Image-Compression-Finished-At':
      headers['x-mobilerecording-image-compression-finished-at'],
    'X-MobileRecording-Image-Compressed':
      headers['x-mobilerecording-image-compressed'],
  };
};

const findAll = (filterQuery?) => {
  return api
    .get(nameSpace + (filterQuery ? filterQuery : ''))
    .then((res) =>
      new Page<MobileInspection>().deserialize(res, MobileInspection),
    )
    .catch((e) => Promise.reject(e));
};

const show = (inspectionId: number) => {
  return api
    .get(nameSpace + '/' + inspectionId)
    .then((res) => new MobileInspection().deserialize(res))
    .catch((e) => Promise.reject(e));
};

const create = (payload) => {
  return api.post(nameSpace, payload);
};

const update = (id, data) => {
  return api.put(`${nameSpace}/${id}`, data);
};

const logRequest = (agentResponseHeaders: AxiosResponseHeaders) => {
  const data = getMonitoringData(agentResponseHeaders);
  return api.post(`${nameSpace}/log_request`, data);
};

const deleteSession = (id, data) => {
  return api.put(`${nameSpace}/${id}`, data);
};

const MobileInspectionService = {
  findAll,
  show,
  create,
  update,
  logRequest,
  deleteSession,
};

export default MobileInspectionService;
